import { media } from '@anm/styles/helpers';
import styled from 'styled-components';

import WaveEventInfo from '../WaveEventInfo';
import ShowOnMobile from '../mobile/ShowOnMobile';

export const WaveEventInfoWrapperTabletStyles = media.tablet`
    height: 100%;
    &:after, &:before {
        display: none;
    }
`;

export const WaveEventInfoBorderedTabletStyles = media.tablet`
    max-height: inherit;
    overflow-x: hidden;
    overflow-y: auto;
    max-width: 100%;
    border-radius: 0;
    padding: 16px 20px 30px;
    height: 100%;
    display: flex;
    flex-direction: column;
`;

export const WaveEventButtonContainerTabletStyles = media.tablet`
    flex-direction: column;
    align-items: stretch;
`;

export const ShowOnMobileButtonsWrapper = styled(ShowOnMobile)`
  flex: 1;
  > * {
    width: 100%;
  }
`;

export const WaveEventInfoBordered = styled(WaveEventInfo)`
  border-radius: 10px;
  padding: 38px 45px 0;
  background-color: #fff;
  max-width: 600px;
  max-height: calc(100vh - 180px);
  overflow: hidden;
  &:hover {
    overflow-y: auto;
    overflow-y: overlay;
  }
  ${WaveEventInfoBorderedTabletStyles};
  &:after {
    display: none;
  }
`;

const WaveEventInfoWrapper = styled.div`
  position: relative;
  &:after,
  &:before {
    width: 100%;
    content: '';
    display: block;
    position: absolute;
    z-index: 1;
    left: 0;
    border-radius: 10px;
  }

  &:after {
    height: 80px;
    bottom: 0;
    background-image: linear-gradient(
      180deg,
      rgba(235, 238, 245, 0) 0%,
      #fff 100%
    );
  }
  &:before {
    height: 50px;
    top: 0;
    background-image: linear-gradient(
      180deg,
      #fff 0%,
      rgba(235, 238, 245, 0) 100%
    );
  }
  &:hover {
    &:after,
    &:before {
      display: none;
    }
  }
  ${WaveEventInfoWrapperTabletStyles};
`;

export const WaveEventButtonContainerTopTabletStyles = media.tablet`
    margin-bottom: 20px;
`;

export const WaveEventButtonContainerBottomTabletStyles = media.tablet`
    > * {
        flex-basis: 50%;
        flex-grow: 0;
        &:nth-child(2) {
          margin-left: 20px;
        }
      }
`;

export const WaveEventButtonContainerTop = styled.div`
  ${WaveEventButtonContainerTopTabletStyles};
`;

export const WaveEventButtonContainerBottom = styled.div`
  display: flex;
  > * {
    &:last-child {
      margin-left: 30px;
    }
  }
  ${WaveEventButtonContainerBottomTabletStyles};
`;

export default WaveEventInfoWrapper;
